import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";

export default {
  getAllGroups,
  getEstateDetailsByGroupID,
  getDivisionDetailsByEstateID,
  GetTasksByOperationEntityID,
  GetPluckingChartReport,
  getCompanyDetailsByGroupID,
  getRegionDetailsByCompanyID,
  getEstateDetailsByRegionID,
};

async function getAllGroups() {
  let response = await CommonGet('/api/Group/GetAllGroups');
  let groupArray = [];
  for (let item of Object.entries(response.data)) {
    if (item[1]["isActive"] === true) {
      groupArray[item[1]["groupID"]] = item[1]["groupName"];
    }
  }
  return groupArray;
};

async function getEstateDetailsByGroupID(groupID) {
  let response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', "groupID=" + parseInt(groupID));
  let estateArray = [];
  for (let item of Object.entries(response.data)) {
    estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
  }
  return estateArray;
};

async function getDivisionDetailsByEstateID(groupID, operationEntityID) {
  const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
  var collectionPointArray = [];
  for (let item of Object.entries(response.data)) {
    if (item[1]["operationEntityID"] === parseInt(operationEntityID) && item[1]["groupID"] === parseInt(groupID) && item[1]["isActive"] === true) {
      collectionPointArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
    }
  }
  return collectionPointArray;
};

async function GetTasksByOperationEntityID(estateID) {
  const response = await CommonGet('/api/PluckingChartReport/GetTasksByOperationEntityID', 'operationEntityID=' + parseInt(estateID))
  return response.data;
}

async function GetPluckingChartReport(model) {
  const response = await CommonPost('/api/PluckingChartReport/GetPluckingChartReport', null, model)
  return response;
}

async function getCompanyDetailsByGroupID(id) {
  var companyArray = [];
  const response = await CommonGet('/api/Company/GetAllCompanyByGroupID', 'groupID=' + id);
  for (let item of Object.entries(response.data)) {
    companyArray[item[1]["companyID"]] = item[1]["companyName"]
  }
  return companyArray;
}

async function getRegionDetailsByCompanyID(id) {
  var regionArray = [];
  const response = await CommonGet('/api/Region/GetAllRegionByCompanyID', 'companyID=' + id);
  for (let item of Object.entries(response.data)) {
    regionArray[item[1]["regionID"]] = item[1]["regionName"]
  }
  return regionArray;
}

async function getEstateDetailsByRegionID(id) {
  var estateArray = [];
  const response = await CommonGet('/api/OperationEntity/GetAllEstatesByRegionID', 'regionID=' + id);
  for (let item of Object.entries(response.data)) {
    estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
  }
  return estateArray;
}